// extracted by mini-css-extract-plugin
module.exports = {"compact":"visTimeline_compact__3RjHh","default":"visTimeline_default__3EDlF"};